const isMobileOS = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isWindowsPhone = /windows phone/i.test(userAgent);
  const isAndroidDevice = /android/i.test(userAgent);

  // Detect iOS:
  // https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
  const isIosDevice =
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
      navigator.platform
    ) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

  // Windows Phone must come first because its UA also contains "Android"
  // can later be reworked to detect which mobile OS
  return isWindowsPhone || isAndroidDevice || isIosDevice;
};

export default isMobileOS;
